export default __webpack_public_path__ + "static/media/starWars.2deee77c.png";